{
  "device": "ADXL345",
  "description": "3-Axis, ±2 g/±4 g/±8 g/±16 g Digital Accelerometer",
  "i2c_addresses": [
    "0x53",
    "0x1D"
  ],
  "registers": [
    {
      "address": "0x00",
      "name": "DEVID",
      "access": "R",
      "format": "u8",
      "reset_value": "0xE5",
      "description": "Device ID",
      "bits": [
        {
          "position": "7:0",
          "name": "DEVID",
          "description": "Fixed device ID code of 0xE5 (345 octal)."
        }
      ]
    },
    {
      "address": "0x2C",
      "name": "BW_RATE",
      "access": "R/W",
      "format": "u8",
      "reset_value": "0x0A",
      "description": "Data rate and power mode control",
      "bits": [
        {
          "position": "4",
          "name": "LOW_POWER",
          "description": "0 = Normal operation, 1 = Reduced power operation."
        },
        {
          "position": "3:0",
          "name": "Rate",
          "description": "Selects device bandwidth and output data rate. Default is 0x0A (100 Hz)."
        }
      ]
    },
    {
      "address": "0x2D",
      "name": "POWER_CTL",
      "access": "R/W",
      "format": "u8",
      "reset_value": "0x00",
      "description": "Power-saving features control",
      "bits": [
        {
          "position": "5",
          "name": "Link",
          "description": "1 = Delays activity function until inactivity is detected."
        },
        {
          "position": "4",
          "name": "AUTO_SLEEP",
          "description": "1 = Enables auto-sleep functionality."
        },
        {
          "position": "3",
          "name": "Measure",
          "description": "0 = Standby mode, 1 = Measurement mode."
        },
        {
          "position": "2",
          "name": "Sleep",
          "description": "0 = Normal mode, 1 = Sleep mode."
        },
        {
          "position": "1:0",
          "name": "Wakeup",
          "description": "Controls frequency of readings in sleep mode (00=8Hz, 01=4Hz, 10=2Hz, 11=1Hz)."
        }
      ]
    },
    {
      "address": "0x31",
      "name": "DATA_FORMAT",
      "access": "R/W",
      "format": "u8",
      "reset_value": "0x00",
      "description": "Data format control",
      "bits": [
        {
          "position": "7",
          "name": "SELF_TEST",
          "description": "1 = Applies a self-test force to the sensor."
        },
        {
          "position": "6",
          "name": "SPI",
          "description": "1 = 3-wire SPI mode, 0 = 4-wire SPI mode."
        },
        {
          "position": "5",
          "name": "INT_INVERT",
          "description": "0 = Interrupts active high, 1 = Interrupts active low."
        },
        {
          "position": "3",
          "name": "FULL_RES",
          "description": "1 = Full resolution mode (4 mg/LSB), 0 = 10-bit mode."
        },
        {
          "position": "2",
          "name": "Justify",
          "description": "1 = Left-justified (MSB) mode, 0 = Right-justified mode with sign extension."
        },
        {
          "position": "1:0",
          "name": "Range",
          "description": "g Range Setting: 00 = ±2g, 01 = ±4g, 10 = ±8g, 11 = ±16g."
        }
      ]
    },
    {
      "address": "0x32",
      "name": "DATAX0",
      "access": "R",
      "format": "i16le",
      "reset_value": "0x00",
      "description": "X-Axis Data LSB+MSB (16-bit signed little-endian)",
      "bits": [
        {
          "position": "7:0",
          "name": "DATAX0",
          "description": "Least significant byte of X-axis output data."
        }
      ]
    },
    {
      "address": "0x33",
      "name": "DATAX1",
      "access": "R",
      "format": "u8",
      "reset_value": "0x00",
      "description": "X-Axis Data 1 (MSB)",
      "bits": [
        {
          "position": "7:0",
          "name": "DATAX1",
          "description": "Most significant byte of X-axis output data."
        }
      ]
    },
    {
        "address": "0x34",
        "name": "DATAY0",
        "access": "R",
        "format": "i16le",
        "reset_value": "0x00",
        "description": "Y-Axis Data LSB+MSB (16-bit signed little-endian)",
        "bits": [
        {
            "position": "7:0",
            "name": "DATAY0",
            "description": "Least significant byte of Y-axis output data."
        }
        ]
    },
    {
        "address": "0x35",
        "name": "DATAY1",
        "format": "u8",
        "access": "R",
        "reset_value": "0x00",
        "description": "Y-Axis Data 1 (MSB)",
        "bits": [
        {
            "position": "7:0",
            "name": "DATAY1",
            "description": "Most significant byte of Y-axis output data."
        }
        ]
    },
    {
        "address": "0x36",
        "name": "DATAZ0",
        "access": "R",
        "format": "i16le",
        "reset_value": "0x00",
        "description": "Z-Axis Data LSB+MSB (16-bit signed little-endian)",
        "bits": [
        {
            "position": "7:0",
            "name": "DATAZ0",
            "description": "Least significant byte of Z-axis output data."
        }
        ]
    },
    {
        "address": "0x37",
        "name": "DATAZ1",
        "format": "u8",
        "access": "R",
        "reset_value": "0x00",
        "description": "Z-Axis Data 1 (MSB)",
        "bits": [
        {
            "position": "7:0",
            "name": "DATAZ1",
            "description": "Most significant byte of Z-axis output data."
        }
        ]
    },
    {
        "address": "0x38",
        "name": "FIFO_CTL",
        "access": "R/W",
        "format": "u8",
        "reset_value": "0x00",
        "description": "FIFO control",
        "bits": [
        {
            "position": "7:6",
            "name": "FIFO_MODE",
            "description": "00 = Bypass, 01 = FIFO, 10 = Stream, 11 = Trigger."
        },
        {
            "position": "5",
            "name": "Trigger",
            "description": "0 = Links trigger event to INT1, 1 = Links trigger event to INT2."
        },
        {
            "position": "4:0",
            "name": "Samples",
            "description": "Specifies how many FIFO entries are needed to trigger a watermark interrupt or are retained before a trigger event."
        }
        ]
    },
    {
        "address": "0x39",
        "name": "FIFO_STATUS",
        "access": "R",
        "format": "u8",
        "reset_value": "0x00",
        "description": "FIFO status",
        "bits": [
        {
            "position": "7",
            "name": "FIFO_TRIG",
            "description": "1 = Trigger event occurred, 0 = No trigger event occurred."
        },
        {
            "position": "5:0",
            "name": "Entries",
            "description": "Reports how many data values are stored in FIFO."
        }
        ]
    }
  ],
  "scripts": [
    {
      "name": "Standard-Initialisierung",
      "description": "Aktiviert den ADXL345 im Messmodus (±2 g, Full Resolution, 100 Hz Ausgaberate)",
      "commands": [
        { "op": "write", "reg": "0x2D", "data": ["0x00"], "comment": "POWER_CTL: Standby/Reset" },
        { "op": "write", "reg": "0x31", "data": ["0x08"], "comment": "DATA_FORMAT: Full Resolution, ±2 g" },
        { "op": "write", "reg": "0x2C", "data": ["0x0A"], "comment": "BW_RATE: 100 Hz" },
        { "op": "write", "reg": "0x2D", "data": ["0x08"], "comment": "POWER_CTL: Measurement Mode aktivieren" }
      ]
    },
    {
      "name": "Device ID prüfen",
      "description": "Liest DEVID-Register und bricht ab, wenn der Wert nicht 0xE5 ist",
      "commands": [
        {
          "op": "poll_until",
          "reg": "0x00",
          "format": "u8",
          "expected": "0xE5",
          "max_tries": 1,
          "delay_ms": 0,
          "comment": "DEVID: Erwarteter Wert 0xE5 (= 345 oktal)"
        }
      ]
    },
    {
      "name": "Achsenwerte lesen",
      "description": "Liest X-, Y- und Z-Beschleunigungswerte (je 16-bit signed)",
      "commands": [
        { "op": "read", "reg": "0x32", "format": "i16le", "comment": "DATAX0: X-Achse" },
        { "op": "read", "reg": "0x34", "format": "i16le", "comment": "DATAY0: Y-Achse" },
        { "op": "read", "reg": "0x36", "format": "i16le", "comment": "DATAZ0: Z-Achse" }
      ]
    }
  ]
}